import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {AuthService} from './services/auth.service';
import {ThemeService} from './services/theme.service';
import {environment} from '../environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, FooterComponent],
  templateUrl: './app.html'
})
export class App {
  authService = inject(AuthService);
  protected readonly isProduction = environment.production;
  // Inject ThemeService to initialize it and apply the dark class on startup
  private themeService = inject(ThemeService);
}
